import core from './core';

export default {
  get({ vendor_id, available, in_stock, search, page, per_page, sort, direction } = {}) {
    return core.get('sims', {
      params: { vendor_id, available, in_stock, search, page, per_page, sort, direction }
    });
  },
}
